import { render, staticRenderFns } from "./TipsPremium.vue?vue&type=template&id=05b27549&scoped=true&"
import script from "./TipsPremium.vue?vue&type=script&lang=js&"
export * from "./TipsPremium.vue?vue&type=script&lang=js&"
import style0 from "./TipsPremium.vue?vue&type=style&index=0&id=05b27549&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b27549",
  null
  
)

export default component.exports